import { useCallback } from 'react';
import { PORTFOLIO_DASHBOARD_ALERT_TYPE_CHANNEL_MANAGER_NOTICES, PORTFOLIO_DASHBOARD_ALERT_TYPE_DUNNING, PORTFOLIO_DASHBOARD_ALERT_TYPE_EXPIRED_OPTIONS, PORTFOLIO_DASHBOARD_ALERT_TYPE_OVERDUE_DEPOSITS } from '../../constants';
import useGlobalSpinner from '../../hooks/useGlobalSpinner';
import { rainbowBaseColors } from '../../palette';
import { handleFetchError, translate } from '../../utils';
import Button from '../Button';

const ALERT_TYPES_DEFINITIONS = {
    [PORTFOLIO_DASHBOARD_ALERT_TYPE_CHANNEL_MANAGER_NOTICES]: {
        calloutStyle: { borderLeftColor: rainbowBaseColors[15] }, // Matches the color of the channel manager notices in the sidebar
        labelTranslationKey: 'PORTFOLIO_DASHBOARD_ALERT_CHANNEL_MANAGER_NOTICES',
        actionPath: '/reservation/index',
    },
    [PORTFOLIO_DASHBOARD_ALERT_TYPE_OVERDUE_DEPOSITS]: {
        calloutStyle: { borderLeftColor: rainbowBaseColors[1] },
        labelTranslationKey: 'PORTFOLIO_DASHBOARD_ALERT_OVERDUE_DEPOSITS',
        actionPath: '/overdue-deposits/index',
    },
    [PORTFOLIO_DASHBOARD_ALERT_TYPE_DUNNING]: {
        calloutStyle: { borderLeftColor: rainbowBaseColors[2] },
        labelTranslationKey: 'PORTFOLIO_DASHBOARD_ALERT_DUNNING',
        actionPath: '/dunning/index',
    },
    [PORTFOLIO_DASHBOARD_ALERT_TYPE_EXPIRED_OPTIONS]: {
        calloutStyle: { borderLeftColor: rainbowBaseColors[3] },
        labelTranslationKey: 'PORTFOLIO_DASHBOARD_ALERT_EXPIRED_OPTIONS',
        actionPath: '/dashboard',
    },
};

/** @param {{ alert: import('./portfolioDashboard.types').PortfolioAlert }} props */
export const PortfolioAlert = function PortfolioAlert({ alert }) {
    const [, setIsLoading] = useGlobalSpinner(false);

    const alertTypeDefinition = ALERT_TYPES_DEFINITIONS[alert.alertType];

    const handlePropertyClick = useCallback(async (event) => {
        event.preventDefault();

        const body = new FormData();
        body.append('property_id', event.currentTarget.dataset.propertyId);
        body.append('sourcePath', alertTypeDefinition.actionPath);

        setIsLoading(true);

        try {
            const response = await fetch('/site/set-property', { method: 'POST', body });

            if (response.ok) {
                window.location.href = (await response.json()).redirectPath;

                return;
            }

            await handleFetchError(response);
        } catch {
            window.alert(translate('frontend', 'ERROR_INPROCESS'));
        }

        setIsLoading(false);
    }, [alertTypeDefinition, setIsLoading]);

    return (
        <div className="callout callout-info flex justify-between items-start gap-3" style={alertTypeDefinition.calloutStyle}>
            <div className="flex justify-between gap-3">
                <span className="font-size-h3 text-bold">{alert.totalCount}</span>
                <p>{translate('frontend', alertTypeDefinition.labelTranslationKey)}</p>
            </div>

            <div className="btn-group">
                <Button type="button" className="btn btn-default btn-sm dropdown-toggle" data-toggle="dropdown">
                    {translate('frontend', 'PORTFOLIO_DASHBOARD_ALERT_ACTION')} <span className="caret" />
                </Button>

                <ul className="dropdown-menu dropdown-menu-right">
                    {alert.propertiesCounts.map((propertyAlertCount) => (
                        <li key={propertyAlertCount.propertyKey}>
                            <a href="#" className="flex justify-between gap-3" data-property-id={propertyAlertCount.propertyId} onClick={handlePropertyClick}>
                                <span>{propertyAlertCount.name}</span>
                                <span className="text-bold">{propertyAlertCount.count}</span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
